<template lang="pug">
  #app
    #navigation(v-if="$route.name !== 'Login' && $route.name !== 'SignUp'")
      Navigation
    #main
      router-view
</template>

<script>
import ConfigService from "@/services/configService";
import Navigation from "@/components/organisms/Navigation.vue";

export default {
  components: {
    Navigation
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["auth/isLoggedIn"];
    },
    me() {
      return this.$store.state["me/me"];
    }
  },
  beforeCreate() {
    // Here we load the base URL and other things
    ConfigService.initApp();

    // Here we set the auth guard. Only when logged in you can see other routers
    this.$router.beforeEach((to, from, next) => {
      if (to.name !== "Login" && to.name !== "SignUp" && !this.isLoggedIn) {
        next({ name: "Login" });
      } else {
        next();
      }
    });
  },
  async beforeMount() {
    // When not logged in we send to login view
    if (
      this.$router.name !== "Login" &&
      this.$router.name !== "SignUp" &&
      !this.isLoggedIn
    ) {
      this.$router.push({ name: "Login" });
    }

    // Here we load the settings
    this.$store.dispatch("settings/find");
  }
};
</script>

<style lang="scss">
@import "~bulma";
@import "~buefy/src/scss/buefy";
@import "@/assets/css/tooltip.scss";

html {
  // background-color: #f2f7fe;
  // background-color: #f8fbff;
  background-color: $background;
  overflow: unset;
  overscroll-behavior-x: none;
}

body {
  margin: 0;
  padding: 0;
  color: $black;
  font-family: $font;
  overscroll-behavior-x: none;
}

h2 {
  margin-top: 1.5rem;
}

#navigation {
  height: 80px;
}

.breaker {
  width: 100%;
  border-bottom: solid 1px $lightgray;
  margin: $md-space 0;
}

.generic-wrapper {
  padding: $md-space;
}

.sub-headline {
  color: $darkgray;
  letter-spacing: -0.025em;
  font-size: 0.875rem;
  margin-top: -1rem;
}

.input-field {
  box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
  max-width: 100%;
  width: 100%;
  background-color: white;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
  -moz-appearance: none;
  -webkit-appearance: none;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.5em;
  justify-content: flex-start;
  line-height: 1.5;
  padding-bottom: calc(0.5em - 1px);
  padding-left: calc(0.75em - 1px);
  padding-right: calc(0.75em - 1px);
  padding-top: calc(0.5em - 1px);
  position: relative;
  vertical-align: top;
}

.card {
  border-radius: 8px;
  overflow: inherit;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
  .top {
    &.between {
      display: flex;
      justify-content: space-between;
    }
    padding: $sm-space $sm-space;
    .left {
      .card-headline {
        color: $darkgray;
        letter-spacing: 0.05em;
        text-transform: uppercase;
        font-size: 0.8125rem;
        font-weight: 700;
      }
      .card-description {
        color: $gray;
        font-size: 0.75rem;
        font-weight: 500;
      }
    }
  }

  .main {
    &.padding {
      padding: 0 $sm-space $sm-space $sm-space;
    }
  }
}

.fully-blocked {
    position: relative;
    overflow: hidden;
    pointer-events: none;
    user-select: none;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(white, 0.88);
      z-index: 5;
    }
    &::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: url("/lock.svg") no-repeat center;
      z-index: 6;
    }
  }

.button-wrapper {
  display: grid;
  grid-auto-flow: column;
  justify-content: flex-start;
  gap: $sm-space;
  &.right {
    justify-content: flex-end;
  }
  &.max {
    width: 100%;
  }
}

.margin-top {
  margin-top: $md-space !important;
}

.form {
  width: 100%;
  max-width: calc(400px + #{$sm-space * 2});
  .field {
    margin-top: $sm-space;
  }
  &.center {
    margin: auto;
  }
  &.max {
    width: 100vw;
  }
  &.w240 {
    max-width: calc(240px + #{$sm-space * 2}) !important;
  }
  &.w400 {
    max-width: calc(400px + #{$sm-space * 2}) !important;
  }
  &.w512 {
    max-width: calc(512px + #{$sm-space * 2}) !important;
  }
  &.w640 {
    max-width: calc(640px + #{$sm-space * 2}) !important;
  }
  &.w960 {
    max-width: calc(960px + #{$sm-space * 2}) !important;
  }
}

.spacer {
  height: $md-space;
  width: $md-space;
  &.sm {
    height: $sm-space;
    width: $sm-space;
  }
  &.inline {
    display: inline-block;
  }
}

.bottom-float {
  position: fixed;
  z-index: 9;
  bottom: $md-space;
  left: 50%;
  transform: translateX(-50%);
  border-radius: 6px;
  padding: $sm-space;
  background-color: white;
  border: solid 1px darken($light, 4%);
  box-shadow: 0px 12px 16px -14px rgba(0, 0, 0, 0.4);
}

.error {
  display: block;
  margin-bottom: 2px;
  color: $danger;
}

.field.is-grouped {
  .field {
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }
}

.button-flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal-card-foot {
  justify-content: flex-end !important;
}
</style>
